import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'


export default {
  getRelatorioResumidoSaidaOperadorTotal(data) {
    return apiCallCenter().post('/relatorios/operadores/saida/resumido/total?_method=GET', data)
  },
  getRelatorioResumidoSaidaOperadorDiaCorrido(data) {
    return apiCallCenter().post('/relatorios/operadores/saida/resumido/dia-corrido?_method=GET', data)
  },
  getRelatorioResumidoSaidaOperadorMediaDia(data) {
    return apiCallCenter().post('/relatorios/operadores/saida/resumido/media-dia?_method=GET', data)
  },
  getRelatorioResumidoSaidaOperadorHora(data) {
    return apiCallCenter().post('/relatorios/operadores/saida/resumido/hora?_method=GET', data)
  },
  getRelatorioResumidoSaidaOperadorMediaHora(data) {
    return apiCallCenter().post('/relatorios/operadores/saida/resumido/media-hora?_method=GET', data)
  },

  exportExcel(params) {
    let query = new URLSearchParams(params.dateTimeRange).toString();

    if(params.operadores.length == 0){
      query = `${query}&operadores[]=${params.operadores}`
    }else{
      params.operadores.forEach(operador => {
        query = `${query}&operadores[]=${operador}`
      })
    }
    if(params.centrosDeCusto.length == 0){
      query = `${query}&centrosDeCusto[]=${params.centrosDeCusto}`
    }else{
      params.centrosDeCusto.forEach(centrosDeCusto => {
        query = `${query}&centrosDeCusto[]=${centrosDeCusto}`
      })
    }
    if(params.maiorQue != 0){
      query = `${query}&maiorQue=${params.maiorQue}`
    }else{
      query = `${query}&maiorQue=0`
    }
    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/operadores/saida/export?${query}`
  },
}
